"use client";

import React, { useState } from "react";
import DemoTopBar from "@/components/demos/real-estate/DemoTopBar";

export default function RealEstateDemoClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [currency, setCurrency] = useState<"INR" | "USD">("INR");
  const [resetKey, setResetKey] = useState(0);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col font-sans selection:bg-amber-500 selection:text-slate-950">
      <DemoTopBar
        currency={currency}
        onCurrencyChange={(c) => setCurrency(c)}
        onResetComplete={() => setResetKey((prev) => prev + 1)}
      />
      <main className="flex-grow" key={resetKey}>
        {React.isValidElement(children)
          ? React.cloneElement(children as React.ReactElement<any>, { currency })
          : children}
      </main>
    </div>
  );
}
